import { BusinessProfileUpdateStrategy } from '../../../../providers/BusinessProfileProvider';

export default {
  modals: {
    update_strategy: {
      title: 'Que localizações devem ser atualizadas?',
      form: {
        update_strategy: {
          options: {
            [BusinessProfileUpdateStrategy.All]: 'Todas as minhas localizações',
            [BusinessProfileUpdateStrategy.Current]: 'Apenas a localização selecionada',
          },
        },
      },
      buttons: {
        confirm: 'Confirmar',
      },
    },
  },
  toasts: {
    error: 'Algo correu mal, tente novamente ou contacte o suporte técnico',
    success: 'As alterações foram guardadas com sucesso!',
  },
};
